
export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.circle   = json.circle
      this.title    = json.title
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      this.angle = {
        size: 180,
        count: 180 / 51.4,
        outY: -this.circle.radius,
        inY: this.circle.tickness - this.circle.radius,
        gridY: [],
        start: 269,
        end: 450,
      }
      this.angle.gridY = [this.angle.inY+5, this.angle.inY+7, this.angle.inY+10]

      this.circle.cx = this.circle.x + this.circle.radius
      this.circle.cy = this.circle.y + this.circle.radius

    },
  }
}